export default __webpack_public_path__ + "static/userJoin2-32b699d9ab767620f4da6e3b7a14829a.jpg";